export default __webpack_public_path__ + "static/media/bday_boy_dp.689fd70a.jpg";